module.exports = __webpack_public_path__ + "img/AT0000002660510.3cfceaa9.png";